import React, { useState, useEffect } from "react";
import UserService from "../services/user.service";
import EventBus from "../common/EventBus";
import { Table, Button, Container, Modal, Form, ButtonGroup, Pagination,Card, Spinner,Row,Col,Alert } from 'react-bootstrap';
import { useSelector } from "react-redux";
import ErrorModal from './ErrorModal';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa'; // Import green and red icons
import { CSVLink } from 'react-csv';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const batchURI= process.env.REACT_APP_API_BATCH_URL;
const directURI= process.env.REACT_APP_API_DIRECT_URL;

const BoardChangeMyPasswordADM = () => {
    const { user: currentUser } = useSelector((state) => state.auth);
  const [formData, setFormData] = useState({
    company_name: '',
        company_mobile_number: '',
        company_email: '',
        contact_first_name: '',
        contact_last_name: '',
        contact_mobile_number: '',
        contact_email: '',
        rec_date: '',
    newPassword: '', // Initial state for newPassword is empty
    confirmPassword: '', // Initial state for confirmPassword is also empty
  });

  const [errors, setErrors] = useState({});
  const [apiErrors, setApiErrors] = useState(null);
  const [apiErrorCode, setApiErrorCode] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState(' Loading, please wait...');
  const [showModal, setShowModal] = useState(false);
  

  // Fetch customer data when the component mounts
  useEffect(() => {
    setLoading(true); // Start loading

    UserService.getAdByIdADM()
      .then((response) => {
        setFormData({
          ...response.data,
          newPassword: '', // Set initial value for newPassword if not present in response
          confirmPassword: '', // Set initial value for confirmPassword
        });
        
        console.log(response.data);
      })
      .catch((error) => handleError(error));
      setLoading(false); // Start loading

      
  }, []);

  const handleError = (error) => {
    if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
    if (error.response) {
      setApiErrors(`Error: ${error.response.data.message}`);
      setApiErrorCode(`Error: ${error.name} - ${error.response.status}`);
    } else if (error.request) {
      setApiErrors('Error: No response received from the server.');
      setApiErrorCode(`Error: ${error.name}`);
    } else {
      setApiErrors(`Error: ${error.message}`);
      setApiErrorCode(`Error: ${error.name}`);
    }
  
    setLoading(false);
    setSuccessMessage(null);
    setShowModal(true);
  };

  const handleBlur = () => {
    validateForm();
 };
  // Handle form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

  };

  const validateForm = () => {
    const newErrors = {};
    
    // Validate new password
    if (!formData.newPassword.trim()) {
      newErrors.newPassword = 'New Password is required';
    } else if (formData.newPassword.length < 8) {
      newErrors.newPassword = 'Password must be at least 8 characters';
    } else if (!/[A-Z]/.test(formData.newPassword)) {
      newErrors.newPassword = 'Password must contain at least one uppercase letter';
    } else if (!/[a-z]/.test(formData.newPassword)) {
      newErrors.newPassword = 'Password must contain at least one lowercase letter';
    } else if (!/[0-9]/.test(formData.newPassword)) {
      newErrors.newPassword = 'Password must contain at least one number';
    } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(formData.newPassword)) {
      newErrors.newPassword = 'Password must contain at least one special character';
    }

    // Validate confirm password
    if (!formData.confirmPassword.trim()) {
      newErrors.confirmPassword = 'Confirm Password is required';
    } else if (formData.confirmPassword !== formData.newPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
    }
  
    console.error('Validation Errors:', newErrors);
    // Finalize validation
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("handle Submit");
    if (validateForm()) {
        setLoadingText(' Updating the data please wait...');
      setLoading(true);
      // Assuming UserService.updateCustomer is an API method to update customer data
    UserService.changeMyPasswordBoardADM(formData)
        .then(() => {
          setSuccessMessage('Password changed successfully!');
          setApiErrors(null); // Clear any previous API errors
          setLoading(false);
        })
        .catch((error) => handleError(error))
    }
  };

  const handleCloseModal = () => setShowModal(false);
  
  return (
    <Container fluid>
  <Row>

        {/* Right Side: Customer Update Form */}
        <Col md={4}>
        <div className="form-container my-4 p-4 border rounded">
          <h2 className="mt-4">Reset your password</h2>
          {/* Display error if it exists */}
          <ErrorModal show={showModal} handleClose={handleCloseModal} errorCode={apiErrorCode} errorMessage={apiErrors} />    
      
          {apiErrors && (
            <Alert variant="danger">
              {apiErrors} (Code: {apiErrorCode})
            </Alert>
          )}
          {successMessage && <Alert variant="success">{successMessage}</Alert>}

          {loading ? (
  <Row className="justify-content-center align-items-center" style={{ height: '100vh' }}>
    <Col className="text-center">
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
      <p>Loading customer data...</p>
    </Col>
  </Row>
          ) : (

            <Form onSubmit={handleSubmit}>
            {/* New Password */}
            <Form.Group controlId="formNewPassword">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                name="newPassword"
                value={formData.newPassword}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.newPassword}
              />
              <Form.Control.Feedback type="invalid">
                {errors.newPassword}
              </Form.Control.Feedback>
            </Form.Group>

            {/* Confirm Password */}
            <Form.Group controlId="formConfirmPassword">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.confirmPassword}
              />
              <Form.Control.Feedback type="invalid">
                {errors.confirmPassword}
              </Form.Control.Feedback>
            </Form.Group>

            {/* Submit Button */}
            <div className=" mt-4">
              <Button variant="primary" type="submit">
              {loading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
                Change My Password
              </Button>
            </div>
          </Form>
           )}
        </div>
        </Col>
       
      </Row>
    </Container>
  );
};

export default BoardChangeMyPasswordADM;
